import httpClient from './http-client';
import mockRoleService from './role.service.mock';

let roleService;

if (process.env.NODE_ENV === 'development') {
  roleService = mockRoleService;
} else {
  roleService = {
    // params: code, name, page, pageSize
    getList(params) {
      return httpClient.get('/role', { params });
    },

    // params: code, name, page, pageSize
    getPublicList(params) {
      return httpClient.get('/role/public', { params });
    },
  };
}

export default roleService;
